import { useState, useEffect } from 'react';
import { api } from '../api/instance';

export const useSlider = () => {
  const [sliders, setSliders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateSliders, setUpdateSliders] = useState(true);

  useEffect(() => {
    const getSliders = async () => {
      try {
        if (updateSliders) {
          setLoading(true);
          const response = await api.get('/sliders');
          console.log('sliders', response.data.sliders);
          setSliders(response.data.sliders);
          setLoading(false);
          setUpdateSliders(false);
        }
      } catch (e) {
        console.log('errors', e);
      }
    };

    getSliders();
  }, [updateSliders]);

  return { sliders, loading };
};
